import { Widget } from '../widget/widget';
import { StudentsStatusWidgetComponent } from './group/widgets/students-status-widget/students-status-widget.component';
import { SurveysWidgetComponent } from './group/widgets/surveys-widget/surveys-widget.component';
import { StudentsProgressWidgetComponent } from './group/widgets/students-progress-widget/students-progress-widget.component';
import { BestCommentsWidgetComponent } from 'app/widget/widgets/best-comments-widget/best-comments-widget.component';
import { StudentsWidgetComponent } from './group/widgets/students-widget/students-widget.component';
import { AutoevaluationWidgetComponent } from './group/widgets/autoevaluation-widget/autoevaluation-widget.component';

export const StudentsStatusWidget = (group, role, id) => {
  return new Widget(StudentsStatusWidgetComponent, {
    id: `widget- '${id}'`,
    name: `widget- '${id}'`,
    class: 'col s12',
    action: 'groups.dashboard',
    key: 'studentsStatus',
    group,
    role
  });
};

export const SurveysWidget = (group, role, id) => {
  return new Widget(SurveysWidgetComponent, {
    id: `widget- '${id}'`,
    name: `widget- '${id}'`,
    class: 'col s12',
    action: 'groups.dashboard',
    group,
    role
  });
};

export const StudentsProgressWidget = (group, role, id) => {
  return new Widget(StudentsProgressWidgetComponent, {
    id: `widget- '${id}'`,
    name: `widget- '${id}'`,
    class: 'col s4',
    action: 'groups.dashboard',
    key: 'totalTrainingHours',
    secondaryKey: 'averageProgress',
    group,
    role
  });
};

export const BestCommentsWidget = (group, role, id) => {
  return new Widget(BestCommentsWidgetComponent, {
    id: `widget- '${id}'`,
    name: `widget- '${id}'`,
    class: 'col s12',
    action: 'groups.dashboard',
    key: 'comments',
    group,
    role,
    query: { groupId: group._id }
  });
};

export const AutoevaluationWidget = (group, role, id) => {
  return new Widget(AutoevaluationWidgetComponent, {
    id: `widget- '${id}'`,
    name: `widget- '${id}'`,
    class: 'col s12',
    action: 'groups.dashboard',
    key: 'autoevaluations',
    group,
    role,
    query: { groupId: group._id }
  });
};

export const StudentsWidget = (group, role, id) => {
  return new Widget(StudentsWidgetComponent, {
    id: `widget- '${id}'`,
    name: `widget- '${id}'`,
    class: 'col s12',
    action: 'groups.dashboard',
    key: 'students',
    group,
    role
  });
};
